/* eslint-disable @typescript-eslint/no-explicit-any */
import localforage from "localforage";
import { IUser, ProgramData } from "@interfaces/Interfaces";
import * as FirebaseService from "./FirebaseService";

/**
 * Subscribes the user to the notification topics for their ContactID and subscribed program IDs
 * @param user
 * @param programs
 * @returns
 */
export async function subscribeToTopics(user: IUser, programs: ProgramData[] | any[]): Promise<boolean> {
  try {
    const existingTopics: string[] | null = await localforage.getItem("notificationTopics");
    const existingTopicsSet = new Set(existingTopics ?? []);

    const topics: string[] = [];

    if (user.userData.contactID) {
      topics.push(`${user.userData.contactID}`);
    }

    if (programs.length > 0) {
      const programIDs = programs.map((item) => item.ID);

      topics.push(...programIDs);
    }

    const sortedTopics = [...topics].sort();
    const sortedExistingTopics = existingTopics ? [...existingTopics].sort() : [];

    if (
      sortedTopics.length === sortedExistingTopics.length &&
      sortedTopics.every((topic, index) => topic === sortedExistingTopics[index])
    ) {
      return true;
    }

    const newTopics = topics.filter((topic) => !existingTopicsSet.has(topic));

    if (newTopics.length > 0) {
      const topicsPromise = newTopics.map((topic) => FirebaseService.addTopic(topic));
      await Promise.all(topicsPromise);

      console.log("Subscribed to new topics: ", newTopics.join(", "));
    }

    await localforage.setItem("notificationTopics", sortedTopics);

    return true;
  } catch (error) {
    console.error("Error in subscribeToTopics:", error);
    return false;
  }
}
